export default "__VITE_ASSET__BmvT21$2__"